import { render } from "./AdminProfileEdit.vue?vue&type=template&id=a97ca3ba"
import script from "./AdminProfileEdit.vue?vue&type=script&lang=js"
export * from "./AdminProfileEdit.vue?vue&type=script&lang=js"
script.render = render

export default script